import { Grid, Layout, Paper, Table, Loader } from "../../components";
import { useAxios } from '../../hooks'
import { Fragment, useContext } from "react";
import { formatDateTime, formatMoney } from "../../utils";
import AuthContext from "../../context/auth";
import { Link } from "@mui/material";
import { BonusPastTwelveMonths } from "./components/BonusPastTwelveMonths/BonusPastTwelveMonths";
import { ThisMonthBonus } from "./components/ThisMonthBonus/ThisMonthBonus";

export function Bonus () {
    const {me} = useContext(AuthContext)

    const [bonus, refetchBonus] = useAxios({
        url: '/bonus',
        params: {
            user_id: me?.id
        }
    })
    
    return (
        <Layout>
            <Grid container justifyContent="center" padding={3} spacing={2}>    
                {bonus.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : ( 
                    <Fragment>
                        <Grid item xs={6} sm={5} maxHeight={'50vh'}>
                            <BonusPastTwelveMonths />
                        </Grid>
                        <Grid item xs={6} sm={5} maxHeight={'50vh'}>
                            <ThisMonthBonus />
                        </Grid>
                    <Grid item xs={12} sm={10}>
                        <Paper elevation={1}>
                        <Table 
                            rowHeight={65}
                            columns={[
                                { field: 'created_at', type: 'dateTime', headerName: 'Data/Hora', flex: 1, valueGetter: ({row}) => row.order.created_at, valueFormatter: ({value}) => {
                                    return formatDateTime(value)
                                }},
                                { field: 'order_id', headerName: 'Emissão', flex: 1, type: 'string', renderCell: ({value}) => (
                                    <Link href={`/admin/emissoes/${value}`}>
                                        #{value}
                                    </Link>
                                )},
                                { field: 'amount', headerName: 'Comissão', flex: 1, valueFormatter: ({value}) => {
                                    return formatMoney(value)
                                }},
                            ]}
                            rows={(bonus?.data || [])}
                        />
                        </Paper>
                    </Grid>
                
                </Fragment>)}
            </Grid>
        </Layout>
    )
}